import * as yup from "yup";

 export const signInSchema = yup.object().shape({
   email: yup.string().email("Wrong email format").required("Email is required"),
 password: yup.string().required("You must enter password"),
});

export const ChangePasswordResetSchema = yup.object().shape({
   email: yup.string().email("Wrong email format").required("Email is required"),
   otp: yup.string().required("You must enter one time password"),
   newPassword: yup.string().required("You must your new password"),
});

export const forgotPasswordSchema = yup.object().shape({
   email: yup.string().email("Wrong email format").required("Email is required"),
 
});

export const changePasswordSchema = yup.object().shape({
  email: yup.string().email("Wrong email format").required("Email is required"),
  oldPassword: yup.string().required("You must enter old password"),
  newPassword: yup.string().required("You must enter new password"),
});

export const addUserSchema = yup.object().shape({
  firstName: yup.string().required("Enter User First Name"),
  lastName: yup.string().required("Enter User Last Name"),
  email: yup.string().email("Wrong email format").required("Email is required"),
  role: yup
    .array()
    .min(1, "Please select at least one role")
    .required("At least 1 role is Required"),
});

export const addmembershipFormSchema = yup.object().shape({
  memberShipCode: yup.string().required("Enter Membership Code"),
  firstName: yup.string().required("Enter First Name"),
  lastName: yup.string().required("Enter Last Name"),
  phoneNumber: yup.string().required("Enter Phone Number"),
  // email: yup.string().email("Wrong email format").required("Email is required"),
  // dateJoined: yup.string().required("Enter Date Joined"),
});

export const addusertypeFormSchema = yup.object().shape({
  email: yup.string().email("Enter Email"),
  phoneNumber: yup.string().required("Enter Phone Number"),
  firstName: yup.string().required("Enter First Name"),
  lastName: yup
    .string()
    .required("Enter Last Name")
    .required("Email is required"),
  // roleNames: yup.string().required("Select Role"),
});

export const addHotelFormSchema = yup.object().shape({
  hotelName: yup.string().required("Enter Hotel Name"),
  location: yup.string().required("Enter Location"),
  contact: yup
    .string()
    .matches(/^[0-9]+$/, "Contact must contain only numbers")
    .required("Enter your phone number"),
  hotelType: yup.string().required("Select hotel Type"),
  roomType: yup.string().required("Enter room Type"),
  amount: yup.string().required("Enter amount"),
});

export const addMembershipTypeFormSchema = yup.object().shape({
  membershipTypeName: yup.string().required("Enter Membership Type Name"),
  earlyBirdAmount: yup.string().required("Enter amount"),
  midBirdAmount: yup.string().required("Enter amount"),
  lateBirdAmount: yup.string().required("Enter amount"),
  attendanceType: yup.string().required("Enter Attendance Type"),
});

export const eventRegFormSchema = yup.object().shape({
  firstName: yup.string().required("Enter First Name"),
  lastName: yup.string().required("Enter Last Name"),
  phoneNumber: yup
    .string()
    .matches(/^[0-9]+$/, "Contact must contain only numbers")
    .required("Enter your phone number"),
  email: yup.string().email("Wrong email format").required("Email is required"),
  photo: yup.mixed().required("Upload Photo is required"),
  // hotel: yup.string().required("SelectThe Hotel"),
  // amount: yup.string().required("Enter amount"),
});

export const addEventSchema = yup.object().shape({
  name: yup.string().required("Enter Event Name"),
  eventType: yup.string().required("Enter Event Type"),
  startDate: yup.string().required("Enter Start Date"),
  endDate: yup.string().required("Enter End Date"),
  information: yup.string().required("Enter Description"),
  location: yup.string().required("Enter Location"),
  eventTime: yup.string().required("Enter Event Time"),
  image: yup.mixed(),
  earlyBirdStartDate: yup.string().required("Enter Early Bird Start Date"),
  earlyBirdEndDate: yup.string().required("Enter Early Bird End Date"),
  midBirdStartDate: yup.string().required("Enter Mid Start Date"),
  midBirdEndDate: yup.string().required("Enter Mid End Date"),
  lateBirdStartDate: yup.string().required("Enter Late Bird Start Date"),
  lateBirdEndDate: yup.string().required("Enter Late Bird End Date"),
  eventCategory: yup.string().required("Enter Event Category"),
});

export const addLogoSchema = yup.object().shape({
  membershipPortalName: yup.string().required("Enter Membership Portal Name"),
  dateCreated: yup.string().required("Enter Date Created"),
  note: yup.string(),
  uploadLogo: yup.mixed().required("Upload Logo"),
  uploadSignature: yup.mixed().required("Upload Signature"),
  eventId: yup.string().required("Select Event"),
});

export const addEventSpeakerSchema = yup.object().shape({
  firstName: yup.string().required("Enter  First Name"),
  lastName: yup.string().required("Enter Last Name"),
  biography: yup.string().required("Enter Biography"),
  topic: yup.string().required("Enter Topic"),
  event: yup.string().required("Enter Event Name"),
  photo: yup.mixed().required("Upload a Photo"),
});

export const editEventSpeakerSchema = yup.object().shape({
  photo: yup.mixed().required("Upload a Photo"),
});

export const feedbackFormSchema = yup.object().shape({
  feedback: yup.string().required("Enter your Feedback"),
  rating: yup
    .number()
    .required("Enter the rating for the feedback")
    .integer("Rating must be an integer")
    .min(1, "Rating must be at least 1")
    .max(5, "Rating must be at most 5"),
  suggestion: yup
    .string()
    .required("Enter the your suggestion for the feedback"),
  // eventId: yup.string().required("Select the event you want to give feedback"),
});

export const reportsSchema = yup.object().shape({
  eventName: yup.string().required("Enter Event Name"),
});

export const attendanceReportSchema = yup.object().shape({
  eventId: yup.number().typeError("Please select an Event").required("Please select an Event"),
  startDate: yup.string().required("Start date is required"),
  endDate: yup.string().required("End date is required"),
  membershipType: yup.string().nullable(),
  attendanceType: yup.string().nullable(),
});

export const verifyPaymentSchema = yup.object().shape({
  referenceNo: yup.string().required("Enter reference number"),
});


export const bulkUploadMemberSchema = yup.object().shape({
  file: yup
    .mixed()
    .required("Upload File is required")
    .test(
      "fileType",
      "Unsupported file format. Only csv, and xlsx files are allowed.",
      (value) => {
        if (!value) return true;
        const supportedFormats = [
          "text/csv",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
        return supportedFormats.includes(value.type);
      }
    ),
});

export const getTagSchema = yup.object().shape({
  reference: yup.string().required("Enter reference number"),
});
